import React, {useState,useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { goToExternalURL, savePayment } from "../../Actions/paymentAction";
import { base_url_client } from "../../Constants/config";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";


const SmryTable = () => {
    const dispatch=useDispatch();
  const navigate=useNavigate();
  const [isLoading, setLoading] = useState(false);
    const storePaymentData = useSelector((state) => state.payment);
    const storeSavePaymentData = useSelector((state) => state.paymentSave);
    const storePreviewData = useSelector((state) => state.saveProfilePreview);
    const { saveProfilePreviewData, loadingData, errorData } = storePreviewData;
    const { paymentData, loading1, error } = storePaymentData;
    const { paymentSaveData, loading, err } = storeSavePaymentData;

    useEffect(() => {
      if (typeof loading !== "undefined" && loading !== null) {
        if (loading === true) {
          setLoading(true);
        } else {
          setLoading(false);
        }
      }
    }, [loading]);

    // useEffect(() => {
    //   if (typeof loader !== "undefined" && loader !== null) {
        
    //     if (loader === true) {
    //       setLoading(true);
    //     } else {
    //       setLoading(false);
    //     }
    //   }
    // }, [loader]);

    useEffect(() => {
      if (typeof paymentSaveData.data !== "undefined" && paymentSaveData.data !== null) {
        if (paymentSaveData?.data?.paymentUrl == null &&  paymentSaveData?.data?.access_code == null) {
          const msg = "Payment successfully";
          toast.success(msg, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
          navigate("/candidate-form/payment-completed");
        } 
        else { 
            dispatch(goToExternalURL(paymentSaveData.data));
        }
      }
    }, [paymentSaveData,storeSavePaymentData]);

const handleCompletePayment=async()=>{
  let InitialCaseId=localStorage.getItem('InitialCaseId');
    let record={};
    record.walletpay=1;
    record.initial_case_id=[InitialCaseId];
    record.amount=paymentData.data.amountToPay;
    dispatch(savePayment(record));
}

  return (
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <h3
            style={{
              position: "absolute",
              width: "208px",
              height: "30px",
              left: "941.21px",
              top: "197.78px",
              fontFamily: "Inter",
              fontStyle: "normal",
              fontWeight: 600,
              fontSize: "20px",
              lineHeight: "30px",
            }}
          >
            Payment: ₹ 7,500.00
          </h3>
          <table className="table table-bordered">
            <tbody>
              <tr>
                <td style={{ color: "#667085", fontSize: "16px" }}>
                  Total Cases
                </td>
                <td style={{ color: "#667085", fontSize: "16px" }}>{paymentData?.data?.paymentData?.length}</td>
              </tr>
              <tr>
                <td style={{ color: "#667085", fontSize: "16px" }}>
                  Total Amount
                </td>
                <td style={{ color: "#667085", fontSize: "16px" }}>
                  ₹ {paymentData?.data?.amountToPay/1.18}
                </td>
              </tr>
              <tr>
                <td style={{ color: "#667085", fontSize: "16px" }}>Taxes</td>
                <td style={{ color: "#667085", fontSize: "16px" }}>
                  ₹ {(paymentData?.data?.amountToPay*0.18)/1.18}
                </td>
              </tr>
              <tr>
                <td
                  style={{
                    color: "#175CD3",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  Total Payable
                </td>
                <td
                  style={{
                    color: "#175CD3",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  ₹ {paymentData?.data?.amountToPay}
                </td>
              </tr>
              <tr>
                <td style={{ color: "black", fontSize: "16px" }}>
                  Use wallet (₹ {paymentData?.data?.walletBalance})
                </td>
                <td style={{ color: "green", fontSize: "16px" }}>
                  - ₹ {paymentData?.data?.amountToPay}
                </td>
              </tr>
            </tbody>
          </table>
          <div className="text-center d-flex justify-content-center">
            <button
              className="btn btn-primary"
              style={{
                boxSizing: "border-box",
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                padding: "12px 85px",
                gap: "8px",
                width: "100%",
                height: "48px",
                background: "#1570EF",
                border: "1px solid #1570EF",
                boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                borderRadius: "8px",
                flex: "none",
                order: 0,
                flexGrow: 0,
              }}
              onClick={handleCompletePayment}
            >
              Complete Payment
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SmryTable;
